import styled from 'styled-components';
import { Button } from '../../../common/components/Button/Button';
import { ButtonVariants } from '../../../common/components/Button/DeprecatedButtonVariants';
import { useNoFilter, useResetFilters } from './useResetFilters';

export const ResetAllButton = () => {
  const handleClick = useResetFilters();

  /** If the mask is empty, there is nothing to reset, so we can hide the button. */
  if (useNoFilter()) return null;

  return (
    <StyledButton onClick={handleClick} variant={ButtonVariants.transparentTeal}>
      Reset all
    </StyledButton>
  );
};

const StyledButton = styled(Button).attrs({ 'data-testid': 'ResetAllButton' })`
  font-size: 16px;
`;
